import React from "react";

export function Money(props: { amount: number }) {
  let amount = props.amount;
  if (Object.is(props.amount, -0)) amount = 0;

  if (isNaN(amount)) {
    return <>-</>;
  }
  return <>{amount.toLocaleString()}</>;
}
